export const categories = [
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line', color: 'bg-rose-100 text-rose-600' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', color: 'bg-violet-100 text-violet-600' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', color: 'bg-amber-100 text-amber-600' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', color: 'bg-cyan-100 text-cyan-600' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line', color: 'bg-emerald-100 text-emerald-600' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', color: 'bg-indigo-100 text-indigo-600' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', color: 'bg-slate-100 text-slate-600' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line', color: 'bg-orange-100 text-orange-600' },
  { slug: 'school', name: '校园', icon: 'ri-book-open-line', color: 'bg-sky-100 text-sky-600' },
  { slug: 'history', name: '历史', icon: 'ri-ancient-gate-line', color: 'bg-stone-100 text-stone-600' },
];

export const comics = [
  {
    id: 1,
    title: '她的私密世界',
    slug: 'her-secret-world',
    category: 'love',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%20in%20a%20romantic%20scene%2C%20soft%20watercolor%20and%20ink%20style%2C%20delicate%20facial%20features%2C%20pastel%20pink%20and%20cream%20background%2C%20dreamy%20atmosphere%2C%20webtoon%20cover%20art%2C%20clean%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    rating: 4.8,
    views: '128万',
    status: '连载中',
    author: '金秀雅',
    summary: '普通上班族李智恩意外发现了自己能够进入他人梦境的能力。在这个奇妙的世界里，她遇见了神秘的男人朴志勋，两人的命运从此交织在一起。一场关于爱情、秘密与成长的奇幻故事就此展开。',
    updateTime: '2026-08-04',
    chapters: 56,
    tags: ['恋爱', '奇幻', '都市'],
  },
  {
    id: 2,
    title: '剑与魔法',
    slug: 'sword-and-magic',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20warrior%20holding%20a%20glowing%20sword%20in%20a%20magical%20forest%2C%20epic%20adventure%20style%2C%20dramatic%20lighting%20with%20golden%20sparkles%2C%20detailed%20armor%20design%2C%20dark%20green%20and%20gold%20color%20scheme%2C%20webtoon%20cover%20art&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    rating: 4.9,
    views: '256万',
    status: '连载中',
    author: '朴俊昊',
    summary: '在魔法与剑并存的世界中，少年艾伦·克劳福德背负着家族的秘密，踏上了寻找传说中的圣剑之旅。一路上他结识了各路伙伴，面对黑暗势力的威胁，他必须变得更强才能守护所爱之人。',
    updateTime: '2026-08-05',
    chapters: 89,
    tags: ['奇幻', '冒险', '战斗'],
  },
  {
    id: 3,
    title: '暗夜追踪者',
    slug: 'night-tracker',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20illustration%20of%20a%20mysterious%20man%20in%20a%20black%20trench%20coat%20standing%20on%20a%20rooftop%20at%20night%2C%20city%20lights%20in%20background%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20cool%20blue%20and%20dark%20gray%20tones%2C%20webtoon%20cover%20art&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    rating: 4.7,
    views: '189万',
    status: '已完结',
    author: '崔明勋',
    summary: '前特种部队成员韩东秀在退伍后成为了一名私家侦探。一个看似普通的失踪案将他卷入了一场涉及政商勾结的巨大阴谋。在追查真相的过程中，他发现自己正在对抗的敌人远比想象中的更加危险。',
    updateTime: '2026-07-20',
    chapters: 120,
    tags: ['动作', '悬疑', '都市'],
  },
  {
    id: 4,
    title: '第七个目击者',
    slug: 'seventh-witness',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20illustration%20of%20a%20detective%20examining%20evidence%20in%20a%20dimly%20lit%20room%2C%20mystery%20and%20suspense%20mood%2C%20cold%20blue%20and%20shadow%20tones%2C%20tense%20atmosphere%2C%20cinematic%20lighting%2C%20webtoon%20cover%20art&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    rating: 4.6,
    views: '145万',
    status: '连载中',
    author: '李恩珠',
    summary: '一起离奇的连环杀人案震惊了整个首尔。六名目击者相继死亡，唯一的线索指向了不存在的"第七个目击者"。刑警姜美娜必须在更多的受害者出现之前，揭开这个令人毛骨悚然的谜团。',
    updateTime: '2026-08-03',
    chapters: 42,
    tags: ['悬疑', '推理', '惊悚'],
  },
  {
    id: 5,
    title: '我的爆笑日常',
    slug: 'my-funny-daily',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20illustration%20of%20a%20cheerful%20young%20woman%20laughing%20with%20her%20friends%20in%20a%20cafe%2C%20bright%20and%20colorful%20slice%20of%20life%20style%2C%20warm%20yellow%20and%20coral%20tones%2C%20expressive%20characters%2C%20webtoon%20cover%20art&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    rating: 4.5,
    views: '98万',
    status: '连载中',
    author: '郑多彬',
    summary: '四个性格迥异的女生合租在一间小小的公寓里，每天都上演着令人捧腹大笑的故事。从搞笑的约会经历到职场囧事，这部漫画用轻松幽默的方式展现了现代都市女性的真实生活。',
    updateTime: '2026-08-05',
    chapters: 78,
    tags: ['喜剧', '日常', '友情'],
  },
  {
    id: 6,
    title: '时光倒流的夏天',
    slug: 'summer-time-reverse',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20illustration%20of%20a%20young%20couple%20walking%20on%20a%20beach%20at%20sunset%2C%20nostalgic%20and%20emotional%20atmosphere%2C%20warm%20orange%20and%20pink%20sunset%20colors%2C%20melancholic%20yet%20beautiful%2C%20webtoon%20cover%20art&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    rating: 4.9,
    views: '312万',
    status: '已完结',
    author: '尹智媛',
    summary: '高中生韩素熙在暑假的最后一天获得了一个神奇的能力——可以回到过去的任意一个夏天。她一次次穿越回那些美好的时光，试图改变遗憾的过去。但每一次的改变都带来了意想不到的连锁反应。',
    updateTime: '2026-06-15',
    chapters: 95,
    tags: ['剧情', '奇幻', '青春'],
  },
  {
    id: 7,
    title: '红衣鬼谈',
    slug: 'red-ghost-story',
    category: 'horror',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20illustration%20of%20a%20ghostly%20figure%20in%20red%20dress%20in%20an%20abandoned%20school%20hallway%2C%20eerie%20and%20chilling%20atmosphere%2C%20dark%20red%20and%20black%20color%20scheme%2C%20creepy%20shadow%20details%2C%20webtoon%20cover%20art&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    rating: 4.4,
    views: '167万',
    status: '连载中',
    author: '宋贤宇',
    summary: '转学生林多海来到一所充满诡异传闻的高中。据说每到午夜，教学楼里就会出现一个穿红裙的女鬼。当他的同学一个接一个地神秘失踪时，他决定揭开这个校园恐怖传说背后的真相。',
    updateTime: '2026-08-02',
    chapters: 34,
    tags: ['恐怖', '校园', '悬疑'],
  },
  {
    id: 8,
    title: '猫咪咖啡厅',
    slug: 'cat-cafe',
    category: 'daily',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cute%20illustration%20of%20a%20girl%20playing%20with%20cats%20in%20a%20cozy%20cafe%2C%20warm%20and%20healing%20atmosphere%2C%20soft%20cream%20and%20beige%20tones%2C%20adorable%20cat%20characters%2C%20webtoon%20cover%20art&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    rating: 4.7,
    views: '89万',
    status: '连载中',
    author: '朴秀珍',
    summary: '辞去大公司工作的金多美开了一家小小的猫咪咖啡厅。在这里，她遇到了各种各样的客人和可爱的猫咪们。每一只猫都有自己的故事，每一位客人都有自己的烦恼，而这家咖啡厅成了治愈心灵的地方。',
    updateTime: '2026-08-04',
    chapters: 67,
    tags: ['日常', '治愈', '温馨'],
  },
  {
    id: 9,
    title: '校园王者',
    slug: 'school-king',
    category: 'school',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20illustration%20of%20a%20confident%20male%20student%20in%20school%20uniform%20at%20a%20classroom%20with%20sunlight%2C%20coming%20of%20age%20story%20style%2C%20bright%20blue%20sky%20and%20white%20tones%2C%20webtoon%20cover%20art&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    rating: 4.6,
    views: '234万',
    status: '连载中',
    author: '张佑赫',
    summary: '普通高中生崔胜贤意外获得了一本神秘的日记，它可以预知未来24小时内发生的事情。利用这个能力，他从学校最不起眼的学生变成了人人敬仰的"校园王者"。但能力越大，责任也越大。',
    updateTime: '2026-08-05',
    chapters: 103,
    tags: ['校园', '奇幻', '成长'],
  },
  {
    id: 10,
    title: '朝鲜王朝秘史',
    slug: 'joseon-secret-history',
    category: 'history',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20illustration%20of%20a%20noblewoman%20in%20traditional%20hanbok%20in%20a%20Joseon%20era%20palace%2C%20elegant%20and%20detailed%20costume%20design%2C%20warm%20earth%20tones%20and%20golden%20accents%2C%20webtoon%20cover%20art&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    rating: 4.8,
    views: '178万',
    status: '已完结',
    author: '韩智慧',
    summary: '以朝鲜王朝中宗时期为背景，讲述了王室内部错综复杂的权力斗争与禁忌之恋。宫女崔尚宫凭借过人的智慧与勇气，在这座金碧辉煌的宫殿中艰难求生，揭开了一个被尘封数百年的王室秘密。',
    updateTime: '2026-05-30',
    chapters: 150,
    tags: ['历史', '剧情', '宫廷'],
  },
  {
    id: 11,
    title: '恋爱方程式',
    slug: 'love-equation',
    category: 'love',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20male%20and%20female%20student%20sharing%20earphones%20in%20a%20library%2C%20sweet%20and%20youthful%20atmosphere%2C%20soft%20pastel%20pink%20and%20mint%20tones%2C%20webtoon%20cover%20art&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    rating: 4.5,
    views: '156万',
    status: '连载中',
    author: '金秀雅',
    summary: '数学天才沈智浩和文学少女刘恩菲是同桌，两人性格截然不同却因为学校的一次合作项目被分到了同一组。在朝夕相处中，两人发现对方身上有着自己从未注意过的魅力。一段甜蜜又令人心动的高中恋爱故事。',
    updateTime: '2026-08-04',
    chapters: 45,
    tags: ['恋爱', '校园', '青春'],
  },
  {
    id: 12,
    title: '异世界餐厅',
    slug: 'another-world-restaurant',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20magical%20restaurant%20with%20floating%20dishes%20and%20mystical%20creatures%2C%20whimsical%20and%20cozy%20atmosphere%2C%20warm%20golden%20lighting%2C%20rich%20food%20details%2C%20webtoon%20cover%20art&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    rating: 4.7,
    views: '201万',
    status: '连载中',
    author: '安成浩',
    summary: '失业厨师金泰浩偶然推开一扇神秘的门，发现自己来到了一个充满精灵、矮人和龙族的异世界。他用现代料理征服了这个世界的味蕾，同时也踏上了一段寻找回家之路的奇妙冒险。',
    updateTime: '2026-08-03',
    chapters: 72,
    tags: ['奇幻', '美食', '冒险'],
  },
];

export const testimonials = [
  { id: 1, name: '小猫咪爱吃鱼', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20cat%20ears%2C%20pastel%20pink%20background%2C%20simple%20clean%20illustration&width=100&height=100&seq=avatar-01&orientation=squarish', comment: '这个网站真的太棒了！漫画资源特别全，更新也很快，画质清晰，阅读体验一流。每天晚上都要刷一会儿才睡觉！', rating: 5 },
  { id: 2, name: '风间琉璃', avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20boy%20avatar%20with%20silver%20hair%2C%20simple%20clean%20illustration%2C%20blue%20background&width=100&height=100&seq=avatar-02&orientation=squarish', comment: '从朋友那里知道的这个网站，下拉式阅读真的爽，不用一页一页翻。分类也很清楚，找漫画很方便。推荐给了好多朋友！', rating: 5 },
  { id: 3, name: '夜雨声烦', avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20with%20glasses%20and%20short%20hair%2C%20simple%20clean%20illustration%2C%20green%20background&width=100&height=100&seq=avatar-03&orientation=squarish', comment: '用了快一年了，漫画种类越来越多，国内外的都有。关键是完全免费，真的很良心。希望网站越做越好，会一直支持下去！', rating: 5 },
];

export const heroSlides = [
  {
    id: 1,
    title: '她的私密世界',
    subtitle: '2026年最受期待恋爱漫画，千万读者的心动之选',
    bg: 'https://readdy.ai/api/search-image?query=Dreamy%20Korean%20manhwa%20style%20illustration%20with%20soft%20romantic%20atmosphere%2C%20floating%20cherry%20blossom%20petals%2C%20warm%20pink%20and%20cream%20gradient%20background%2C%20ethereal%20lighting%2C%20artistic%20watercolor%20texture%2C%20wide%20cinematic%20composition&width=1600&height=800&seq=hero-bg-01&orientation=landscape',
    cta: '开始阅读',
    link: '/article/1',
  },
  {
    id: 2,
    title: '剑与魔法',
    subtitle: '史诗级奇幻冒险，全网评分最高的热血漫画',
    bg: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20Korean%20manhwa%20illustration%20with%20golden%20magical%20energy%20and%20ancient%20ruins%2C%20dramatic%20sunset%20sky%2C%20warm%20amber%20and%20crimson%20gradient%20background%2C%20mystical%20atmosphere%2C%20wide%20cinematic%20composition&width=1600&height=800&seq=hero-bg-02&orientation=landscape',
    cta: '立即探索',
    link: '/article/2',
  },
  {
    id: 3,
    title: '时光倒流的夏天',
    subtitle: '百万读者泪目推荐，触动心灵的治愈神作',
    bg: 'https://readdy.ai/api/search-image?query=Nostalgic%20summer%20Korean%20manhwa%20illustration%20with%20ocean%20and%20warm%20sunlight%2C%20golden%20hour%20glow%2C%20soft%20orange%20and%20peach%20gradient%20background%2C%20dreamy%20beach%20scene%2C%20wide%20cinematic%20composition&width=1600&height=800&seq=hero-bg-03&orientation=landscape',
    cta: '开始阅读',
    link: '/article/6',
  },
];